import styled from "styled-components";

export const InfoContainer = styled.div`
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  margin-bottom: 20px;
  overflow: hidden;
`;

export const InfoHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #dee2e6;
  }
`;

export const InfoTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #595959;
`;

export const ToggleButton = styled.div`
  color: #595959;
  display: flex;
  align-items: center;
`;

export const InfoContent = styled.div`
  padding: 0 20px 20px 20px;
  animation: slideDown 0.3s ease;
  
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const InfoTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid #e9ecef;
  
  ${props => props.$isHeader && `
    background-color: #f8f9fa;
  `}
  
  &:last-child {
    border-bottom: none;
  }
`;

export const TableHeader = styled.th`
  padding: 12px;
  text-align: left;
  font-weight: 600;
  font-size: 13px;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const TableCell = styled.td`
  padding: 12px;
  font-size: 14px;
  color: #333;
`;

export const IconCell = styled.td`
  padding: 12px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  
  color: ${props => props.$success ? '#595959' : props.$error ? '#1a1a1a' : '#333'};
`;
